<template>
  <my-chart
    :loading="loading"
    :option="option"
    v-bind="$attrs"
    :dataset="chartData"
    v-on="$listeners"
  />
</template>
<script>
import MyChart from './MyChart.vue';
import { getChart } from './constant.js';

export default {
  name: 'CsChart',
  components: { MyChart },
  props: {
    type: {
      type: String,
      required: false,
      default: 'line',
      validator: (value) => {
        return !!getChart(value);
      },
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    dataset: {
      type: [Object, Array, Function],
      default: () => null,
    },
  },
  data() {
    return {
      chartData: null,
    };
  },
  computed: {
    option() {
      return (getChart(this.type) || getChart('line')).option;
    },
  },
  mounted() {
    this.getChartdata(this.dataset);
  },
  watch: {
    dataset(value) {
      this.getChartdata(value);
    },
  },
  methods: {
    getChartdata(value) {
      if (!value) {
        this.chartData = null;
        return;
      }
      if (typeof value === 'function') {
        value().then((data) => {
          this.chartData = data;
        });
      } else {
        this.chartData = value;
      }
    },
  },
};
</script>
